<template>
    <MainContainer>
        <div class="offene-posten position-relative">
            <h2>
                Offene Posten
                <b-button
                    v-if="checkRight('write')"
                    :size="size"
                    :to="{
                        path: '/fibu/offene_posten/new'
                    }"
                >
                    Neu / Vorauszahlung
                    <font-awesome-icon icon="plus" />
                </b-button>
            </h2>
            <FiBuOPFilter
                :mitglieder="mitglieder"
                :mahnungen="mahnungen"
                @submit="updateFilter"
                @mahnungen="updateFilter"
                @filterChanged="setFilterChangedStatusTrue"
            />
            <FiBuOPList
                :filter="filter"
                :mitglieder="mitglieder"
                :filterChanged="filterChanged"
                @resetMahnungen="mahnungen.reset = true"
                @loadingMahnungen="mahnungen.busy = true"
                @mahnungenLoaded="mahnungen.busy = false"
            />
            <FixedBottomBar_OP :sums="totalSums" />
        </div>
    </MainContainer>
</template>

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import Currency from "@/mixins/Currency/Currency";
import Validation from "@/mixins/Validation/Validation";
import { ApiFactory } from "@/api/ApiFactory.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import FiBuOPFilter from "@/components/FiBuOPFilter/FiBuOPFilter";
import FiBuOPList from "@/components/FiBuOPList/FiBuOPList";
import FixedBottomBar_OP from "@/components/FixedBottomBar_OP/FixedBottomBar_OP";
import Rights from "@/mixins/Rights/Rights";

const FiBuOffenePostenApi = ApiFactory.get("fibuOffenePosten");
const MitgliederApi = ApiFactory.get("mitglieder");

export default {
    name: "FiBu_OffenePosten",
    mixins: [CommonView, Size, Currency, Validation, Rights],
    components: {
        MainContainer,
        FiBuOPFilter,
        FiBuOPList,
        FixedBottomBar_OP
    },
    data() {
        return {
            api: FiBuOffenePostenApi,
            mitgliederApi: MitgliederApi,
            prefetch: false,
            filter: null,
            filterChanged: false,
            mitglieder: {
                busy: false,
                items: [],
                options: []
            },
            sums: {
                busy: false,
                items: {
                    income: 0,
                    outcome: 0,
                    total: 0
                }
            },
            totalSums: {
                total: 0,
                open: 0,
                paid: 0
            },
            mahnungen: {
                busy: false,
                reset: false
            }
        };
    },
    async created() {
        this.fetchMitglieder();
    },
    methods: {
        async fetchSums() {
            this.sums.busy = true;

            const response = await FiBuOffenePostenApi.getSums({
                filter: this.filter
            });

            if(response.ok) {
                this.totalSums.total = response.json.sums.total;
                this.totalSums.open = response.json.sums.open;
                this.totalSums.paid = response.json.sums.paid;
            } else {
                this.showError(
                    'Fehler bei Summenbildung',
                    'Leider konnten die Summen für die abgfragten offenen Posten nicht gebildet werden. Versuchen Sie es erneut!',
                );
            }

            this.sums.busy = false;
        },
        async fetchMitglieder() {
            this.mitglieder.busy = true;

            const response = await MitgliederApi.get({
                fields: ["id", "vorname", "name"],
                order: "name",
                sort: "asc",
                limit: -1
            });
            if (response.ok) {
                const items = response.json.collection;
                this.mitglieder.items = items;
                this.mitglieder.options = items.map(item => {
                    return {
                        text: `${item.name}, ${item.vorname} (${item.id})`,
                        value: item.id
                    };
                });
                this.registerRights(response)
            }
            this.mitglieder.busy = false;
        },
        updateFilter(filter) {
            this.sums.busy = true;
            this.filter = Object.assign({}, filter);
            this.filterChanged = false;
        },
        postProcessCreate(selectedItem, response) {
            selectedItem.id = response.json.id;
            return selectedItem;
        },
        fetchErrorHandling(response) {
            this.handleValidationData(response, this.ioFields);
        },
        postDataSet() {
            this.cleanValidationData(this.ioFields);
        },
        setFilterChangedStatusTrue() {
            this.filterChanged = true;
        },
        // resetMahnungen() {
        //     console.log('reset')
        //     this.filter = {...this.filter, mahnungen: null}
        //    this.filter.mahnungen = null;
        //     console.log("reseted", this.filter.mahnungen)
        //     console.log(this.filter)
        // }
    },
    watch: {
        filter: {
            handler(val) {
                if (val) {
                    this.fetchSums();
                }
            }
        }
    }
};
</script>
